import { render, staticRenderFns } from "./VendorVacationEdit.vue?vue&type=template&id=5585cbf2"
import script from "./VendorVacationEdit.vue?vue&type=script&lang=js"
export * from "./VendorVacationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports